<template>
  <div>
    <ModalAccount
      v-if="accountList"
      ref="ModalAccount"
      :account="accountList"
      @action="selectAccount"
    ></ModalAccount>
    <modalcart v-model="dialog" />
    <v-snackbar
      v-model="alert.show"
      timeout="2000"
      right
      top
      :color="alertColor"
    >
      {{ alert.message }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="hideAlert">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-app-bar fixed>
      <v-toolbar elevation="0" class="header-frame">
        <div class="d-none d-sm-block">
          <a :href="homepage" class="d-none d-md-block">
            <v-img contain max-width="180" max-height="60" :src="siteConfig.logo"></v-img>
          </a>
        </div>
        <v-btn
          text
          small
          link
          :href="homepage"
          class="d-block d-md-none px-0"
        >
          <v-icon class="">mdi-home</v-icon>
        </v-btn>
        <div id="feature-bar">
          <v-col class="mt-0 px-0 px-md-3 px-3" id="search-bar">
            <v-form @submit.prevent="cari" role="form">
              <v-text-field
                flat
                solo
                v-model="search_text"
                hide-details
                :placeholder="'Cari di ' + siteConfig.meta_title"
                prepend-inner-icon="mdi-magnify"
                variant="solo-filled"
                class="rounded-xl text-caption text-sm-body-2"
                @click:append="cari"
              ></v-text-field>
            </v-form>
          </v-col>

        </div>
        <v-btn
          target="_blank"
          link
          :href="'https://wa.me/' + siteConfig.config_phone"

          text
          ><v-icon>mdi-headset</v-icon>
        </v-btn>
        <div class="pl-2 pr-2 d-none d-md-inline" id="cart-bar">
          <v-btn
          text link :href="homepage + 'cart'">
            <v-badge offset-x="-2" color="success" overlap :value="cartProduk(cartData)">
            <template #badge>
              <span style="font-size: 10px">{{ cartProduk(cartData) }}</span>
            </template>
            <v-icon class="py-1" >mdi-cart</v-icon>
          </v-badge>
          </v-btn>
        </div>



        <!-- <template v-if="isAuth">
          <a
            title="Toko Saya"
            class="text-deco ml-5 mr-3"
            @click="gotoMyStore"
            v-if="
              ['seller', 'stockist', 'reseller'].includes(
                userData.user_type || ''
              )
            "
          >
            <span
              class="ml-n1 d-flex justify-content-center"
              style="align-items: center"
            >
              <v-img
                style="filter: brightness(0) invert(1)"
                width="30"
                src="/assets/icons/icon-toko1.svg"
              ></v-img>
              <span class="white--text font-weight-black d-none d-md-block"
                >Toko Saya</span
              >
            </span>
          </a>
          <a
            title="Buka Toko"
            href="javascript:void(0)"
            class="text-deco white--text mr-3 my-auto"
            @click="$router.push({ name: 'buka-toko' })"
            v-else
          >
            <span
              class="ml-n1 d-flex justify-content-center"
              style="align-items: center"
            >
              <v-img
                style="filter: brightness(0) invert(1)"
                width="30"
                src="/assets/icons/icon-toko1.svg"
              ></v-img>
              <span class="black--text font-weight-black d-none d-md-block"
                >Buka Toko</span
              >
            </span>
          </a>
        </template>  -->
        <v-menu
          dark
          offset-y
          class="d-none d-sm-block d-xs-none pl-2"
          id="user-bar"
          v-if="isAuth"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              text
              v-bind="attrs"
              v-on="on"
              class="px-0 bg-transparent d-none d-md-block"
              id="userbtn-bar"
              elevation="0"
            >
              <div class="font-weight-bold d-flex" style="align-items: center">
                <div class="d-block">
                  <v-icon width="30">mdi-account</v-icon>
                </div>
                <!-- <span class="d-none d-sm-block d-xs-none pl-2">
                  {{ userData ? userData.user_name : "" }}
                </span> -->
              </div>
              <v-icon class="d-none d-sm-block">mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list light>
            <v-list-item link to="/profile">
              <v-list-item-avatar>
                <v-img
                  v-if="userData.user_image"
                  :src="userData.user_image"
                  alt=""
                />
                <v-icon v-else>mdi-account</v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>{{ userData.user_name }}</v-list-item-title>
                <v-list-item-subtitle style="text-transform: capitalize">
                 {{ detailProfile.user_member_type ? 'Member ' + detailProfile.user_member_type : '' }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list light>
            <v-divider class="my-0"></v-divider>
            <template v-for="(item, index) in menu">
              <template v-if="item.show">
                <template v-if="!item.external">
                  <v-list-item link :key="index" :to="item.link">
                    <v-list-item-content>
                      <v-list-item-title>{{ item.name }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <template v-else>
                  <v-list-item link :key="index" :href="item.link">
                    <v-list-item-content>
                      <v-list-item-title>{{ item.name }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </template>
            </template>
            <v-list-item link @click.native="changeAccount" v-if="accountList">
              <!-- <v-icon class="pr-3 grey--text text--darken-1">mdi-account-details-outline</v-icon> -->
              <v-list-item-content>
                <v-list-item-title class="grey--text text--darken-2"
                  >Ganti Akun</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <!-- <v-list-item
                link
                @click.native="gotoMyStore"
                v-if="
                  ['seller', 'stockist', 'reseller'].includes(
                    userData.user_type
                  )
                "
              >
                <span class="pr-2 ml-n1">
                </span>
                <v-list-item-content>
                  <v-list-item-title class="grey--text text--darken-2"
                    >Toko Saya</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item link @click.native="gotoHelp">
                <span>
                </span>
                <v-list-item-content>
                  <v-list-item-title class="grey--text text--darken-1"
                    >Bantuan</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>-->
            <v-list-item link @click.native="onLogout">
              <!-- <v-icon class="pr-3 grey--text text--darken-1">mdi-exit-to-app</v-icon> -->
              <v-list-item-content>
                <v-list-item-title class="grey--text text--darken-2"
                  >Logout</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
        <template v-else>
          <v-btn link to="/login" class="d-none d-md-block py-2" text
            >Login</v-btn
          >
          <v-btn
            link
            to="/register"
            class="d-none d-md-block py-2"
            color="primary"
            >Register</v-btn
          >
        </template>
        <!-- <div class="d-md-none d-flex">
          <v-app-bar-nav-icon
            @click="drawer = !drawer"
            class="d-md-none d-block"
          ></v-app-bar-nav-icon>
        </div> -->
      </v-toolbar>
    </v-app-bar>
    <!-- <NavigationDrawer
      :userData="userData"
      :isAuth="isAuth"
      :siteConfig="siteConfig"
    /> -->
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import ModalAccount from "@/views/store/login/ModalChooseAccount";
// import categoryVue from "../../category.vue";
// import NavigationDrawer from "./NavigationDrawer.vue";
export default {
  components: {
    ModalAccount,
    // NavigationDrawer,
    // categoryVue
  },
  data() {
    return {
      searchDrawer: false,
      homepage: process.env.VUE_APP_HOMEPAGE,
      dialog: false,
      categoryDrawer: false,
      items: [
        { title: "Click Me" },
        { title: "Click Me" },
        { title: "Click Me" },
        { title: "Click Me 2" },
      ],
    };
  },
  computed: {
    menu() {
      return [
        {
          name: "Beranda",
          show: true,
          link: process.env.VUE_APP_HOMEPAGE,
          external: true,
        },
        {
          name: "Profile",
          show: true,
          link: "/profile",
        },
        {
          name: "Toko Saya",
          show: ["seller", "stockist", "reseller"].includes(
            this.userData.user_type || ""
          ),
          link: "/seller/dashboard",
        },
        // {
        //   name: "Buka Toko",
        //   show: !['seller', 'stockist', 'reseller'].includes(this.userData.user_type || ''),
        //   link: "/seller/dashboard",
        // },
        {
          name: "Transaksi",
          show: true,
          link: "/transaction",
        },
      ];
    },
    drawer: {
      get() {
        return this.$store.state.drawer;
      },
      set(value) {
        this.$store.commit("SET_DRAWER", value);
      },
    },
    ...mapState("kiriminaja", ["siteConfig"]),
    currentRouteName() {
      return this.$route.name;
    },
    ...mapState("profile", ["detailProfile"]),
    ...mapState("auth", ["isAuth", "userData", "accountList"]),
    ...mapState(["alert"]),
    ...mapState("cart", ["cartData"]),
    userType() {
      if (this.userData) return this.userData.userType;
      return "";
    },
    showCategory() {
      return !this.$route.path.includes("search");
    },
    windowWidth() {
      let screen = document.documentElement.clientWidth;
      if (screen <= 960) return "0";
      else return "60";
    },
    alertColor() {
      switch (this.alert.type) {
        case "success":
          return "primary";
        case "warning":
          return "yellow";
        default:
          return "red";
      }
    },
  },
  methods: {
    ...mapActions("kiriminaja", ["getSiteConfig"]),
    ...mapActions("auth", ["logout"]),
    ...mapMutations(["hideAlert"]),
    ...mapMutations("auth", ["success"]),
    ...mapActions("cart", ["getCart"]),
    ...mapMutations("cart", ["setCart"]),
    getWindowWidth() {
      let screen = document.documentElement.clientWidth;
      if (screen <= 960) this.isMobile = "0";
      else this.isMobile = "70";
    },
    changeAccount() {
      this.$refs.ModalAccount.modalShow();
    },
    selectAccount(data) {
      this.success(data);
      location.reload();
    },
    wdrawer() {
      if (window.matchMedia("(min-width: 600px)").matches) {
        this.drawer = false;
      }
    },
    gotoBukaToko() {
      this.$router.push({ name: "buka-toko" });
    },
    gotoProfile() {
      this.$router.push({
        name: "profile",
      });
    },
    gotoMyStore() {
      // let routeData = this.$router.resolve({ name: "seller-dashboard" });
      // window.open(routeData.href, "_blank");
      this.$router.push({
        name: "seller-dashboard",
      });
    },
    gotoTransaction() {
      this.$router.push("/transaction").catch(() => {});
    },
    gotoHelp() {
      window.location.href = process.env.VUE_APP_CHAT;
      return false;
    },
    onLogout() {
      // this.logout().then(() => {
      //   this.$router.push({
      //     name: "login"
      //   });
      // });
      this.$store.dispatch("auth/logout").then(() => {
        // window.location.href = `${process.env.VUE_APP_HOMEPAGE}`;
        window.location.replace(process.env.VUE_APP_HOMEPAGE + "logout ");
      });
    },
    cari() {
      if (this.search_text) {
        let link = this.search_text
          .toString()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase()
          .trim()
          .replace(/\s+/g, "-")
          .replace(/[^\w-]+/g, "")
          .replace(/--+/g, "-");
        window.location.href =
          process.env.VUE_APP_HOMEPAGE + "search?search=" + link;
        // this.$router.push({
        //   path: "/search",
        //   query: {
        //     search: link,
        //     type: "product",
        //   },
        // });
      }
    },
    clearSearch() {
      this.searchDrawer = false;
    },
    cartProduk(data) {
      let count = 0;
      data.forEach((el) => {
        el.cart_detail.forEach(() => {
          count += 1;
        });
      });
      return count;
    },
  },
  watch: {
    $route(val) {
      if (val.name == "search") {
        this.search_text = val.query.search || "";
      } else {
        this.search_text = "";
      }
    },
  },
  async beforeMount() {
    await this.getSiteConfig();
    // console.log("siteconf", this.siteConfig.favicon)
    var link =
      (await document.querySelector("link[rel*='icon']")) ||
      document.createElement("link");
    link.type = await "image/x-icon";
    link.rel = await "shortcut icon";
    link.href = await this.siteConfig.favicon;
    await document.getElementsByTagName("head")[0].appendChild(link);
  },
  created() {
    if (this.isAuth) {
      this.getCart();
    } else {
      this.setCart({ data: [], pagination: {} });
    }
    // window.addEventListener("resize", this.wdrawer);
  },
  destroyed() {
    // window.removeEventListener("resize", this.wdrawer);
  },
};
</script>

<style lang="scss" scoped>
#feature-bar {
  text-align: right;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  flex: auto;
  // padding-left: 25px;
}

.small-logo {
  // background: #fff;
  width: 65px;
  height: 40px;
  padding: 6px 8px;
  border-radius: 4px;

  .v-image {
    display: block;
    margin: 0 auto;
  }
}

#mini-search-bar {
  .v-image {
    .v-image__image {
      background-size: 20px !important;
    }
  }
}

#search-drawer-bar {
  display: none;
}

@media (max-width: 599px) {
  #cart-bar,
  #message-bar,
  #mini-search-bar {
    padding-left: 7px !important;
    padding-right: 7px !important;
  }

  #search-drawer-bar {
    display: flex;
  }
}

.invert {
  filter: brightness(1) invert(1);
}
</style>
